import { IconText as AntdIconText } from "@empglabs/backoffice-ui-kit"

const IconText = props => {
  return <AntdIconText {...props} />
}

export default IconText
